const amount = value => typeof value === 'number' && Number.isFinite(value) && value >= 0;

export const bundleAvailable = (bundle, cfg, pricing) => {
  const total = pricing?.presets?.[bundle?.id];
  return !!bundle && Array.isArray(bundle.composition) && bundle.composition.length > 0
    && bundle.composition.every(slug => cfg.automations.some(o => o.slug === slug && o.visible !== false))
    && !!total && ['setup_total', 'monthly', 'subtotal', 'pct'].every(key => amount(total[key]));
};

export const consistentCatalog = (cfg, pricing) => {
  if (!cfg?.catalog_version || cfg.catalog_version !== pricing?.catalog_version) {
    throw new Error('version_mismatch');
  }
  if (!['automations', 'presets', 'packages'].every(key => Array.isArray(cfg[key]))
      || !pricing.presets || !Array.isArray(cfg.managed_care?.points)
      || !cfg.software_disclaimer || !cfg.pilot_offer) throw new Error('invalid_catalog');
  const automations = cfg.automations.filter(o => o && o.visible !== false);
  if (automations.some(o => !o.slug || !o.name || !amount(o.startingBuildPrice)
      || !amount(o.newAgreementManagementPrice) || !Array.isArray(o.integrations))
      || cfg.presets.some(b => !b?.id || !b.name || !Array.isArray(b.composition))) {
    throw new Error('invalid_catalog');
  }
  return {cfg: {...cfg, automations}, pricing};
};